import React, { useState, useEffect } from 'react';

export default function LogoKawesCar({ className = '', size = 'default', showText = true, variant = 'default' }) {
  const [imageError, setImageError] = useState(false);
  const [currentImagePath, setCurrentImagePath] = useState(null);

  // Tamaños predefinidos para la imagen del logo (aumentados 30% para mejor visualización)
  const sizes = {
    small: { width: 65, height: 65, textSize: 'text-lg' },
    default: { width: 104, height: 104, textSize: 'text-2xl' },
    large: { width: 156, height: 156, textSize: 'text-3xl' },
    xl: { width: 234, height: 234, textSize: 'text-4xl' }
  };

  const config = sizes[size] || sizes.default;
  const isLight = variant === 'light' || className.includes('text-white');

  // Rutas posibles para la imagen del logo del robot mascota
  const possiblePaths = [
    '/images/kawescar-logo-robot.png',
    '/images/kawescar-logo.png',
    '/images/kawescar-robot.png',
    '/images/logo-kawescar.png',
    '/images/KawesCar-logo.png',
    '/images/KAWESCAR-logo.png',
  ];

  // Intentar cargar la primera imagen disponible
  useEffect(() => {
    const testImage = (path, index) => {
      const img = new Image();
      img.onload = () => {
        setCurrentImagePath(path);
        setImageError(false);
      };
      img.onerror = () => {
        if (index < possiblePaths.length - 1) {
          // Intentar la siguiente ruta
          testImage(possiblePaths[index + 1], index + 1);
        } else {
          // Todas las rutas fallaron
          setImageError(true);
        }
      };
      img.src = path;
    };

    if (possiblePaths.length > 0) {
      testImage(possiblePaths[0], 0);
    }
  }, []);

  const logoImagePath = currentImagePath || possiblePaths[0];

  return (
    <div className={`flex min-w-0 items-center gap-3 ${className}`}>
      {/* Imagen del logo - Robot mascota de KawésCar */}
      <div 
        className="flex-shrink-0"
        style={{ width: config.width, height: config.height }}
      >
        {!imageError && currentImagePath ? (
          <img
            src={currentImagePath}
            alt="KawésCar Logo - Robot Mascota"
            className="w-full h-full object-contain"
            onError={() => {
              console.warn('No se pudo cargar la imagen del logo:', currentImagePath);
              setImageError(true);
            }}
          />
        ) : imageError ? (
          // Fallback si la imagen no se carga - mostrar texto simple
          <div 
            className={`flex items-center justify-center rounded-full ${
              isLight ? 'bg-white/20 text-white' : 'bg-blue-600 text-white'
            }`}
            style={{ width: config.width, height: config.height }}
          >
            <span className="font-bold text-sm">KC</span>
          </div>
        ) : (
          // Estado de carga inicial - mostrar placeholder
          <div 
            className={`flex items-center justify-center rounded-full ${
              isLight ? 'bg-white/10 text-white' : 'bg-gray-200 text-gray-400'
            }`}
            style={{ width: config.width, height: config.height }}
          >
            <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
      </div>

      {/* Texto del logo */}
      {showText && (
        <div className="flex min-w-0 flex-col">
          <span className={`truncate font-bold ${isLight ? 'text-white' : 'text-blue-600'} ${config.textSize} leading-tight`}>
            KawésCar
          </span>
          <span className={`line-clamp-2 text-xs font-medium leading-tight ${isLight ? 'text-blue-100' : 'text-gray-500'}`}>
            La Plataforma Digital del Sector Automotriz en Chile
          </span>
        </div>
      )}
    </div>
  );
}
